import React, { useEffect, useState } from 'react'
import BoxOneTable from './BoxOneTable'
import { getSeriesesInBoxAPI } from '../../../api/pack/seriesAPI'
import { useSelector } from 'react-redux'

const BoxOneList = ({ boxId }) => {

    const goodId = useSelector(state => state.box.goodId)

    const [count, setCount] = useState(0)
    const [limit, setLimit] = useState(10)
    const [offset, setOffset] = useState(0)
    const [query, setQuery] = useState('')

    const [serieses, setSerieses] = useState([])

    useEffect(() => {
        getSeriesesInBoxAPI({ boxId, goodId, offset, limit, query }).then(data => {
            setCount(data.count)
            setSerieses(data.serieses)
        }).catch(e => {
            
        })
    }, [boxId, goodId, limit, offset, query])

  return (
    <div>
        <BoxOneTable
            boxId={boxId}
            serieses={serieses}
            count={count}
            limit={limit}
            setLimit={setLimit}
            offset={offset}
            setOffset={setOffset}
        />
    </div>
  )
}

export default BoxOneList